<div class="settings-general-container">
  <h4>General</h4>
  @for (setting of [
    { key: 'showGrid', label: 'Show Grid' },
    { key: 'showLighting', label: 'Show Lighting' },
    { key: 'showCrosshair', label: 'Show Crosshair' },
    { key: 'showCenterCoordinate', label: 'Show Center Coordinate' },
    { key: 'clusterFirstResponders', label: 'Cluster First Responders' }
    ]; track setting) {
    <div
      class="settings-row"
      >
      <label class="toggle-switch">
        <!-- Pass the actual setting.key when toggled -->
        <input
          type="checkbox"
          [(ngModel)]="settings[setting.key]"
          (ngModelChange)="onSettingChange(setting.key)"
          />
          <span class="toggle-slider"></span>
        </label>
        <span class="settings-label">{{ setting.label }}</span>
      </div>
    }
  </div>
